export enum TerminalAuthStatus {
  /** 正常 */
  normal = 0,
  /** 未授权 */
  unauthorized = 1,
  /** 未订阅 */
  unsubscribed = 2,
}

export const TerminalAuthStatusLabel = {
  /** 正常 */
  0: '正常',
  /** 未授权 */
  1: '未配置',
  /** 未订阅 */
  2: '未订阅',
}
